import classNames from 'classnames';
import Color from 'color';

import styles from './styles.less';

import { resolveIconClass, IconElt } from './icon-helpers';
import { badges } from './badge';

export function isDark({ r, g, b }) {
    const lumens = 0.299 * r + 0.587 * g + 0.114 * b;
    return lumens <= 0.5 * 255;
}


//With a circle
export function PointIcon({ iconClass, shape = undefined, asText = undefined, renderPoint, iconSize, type, pointRgb, pointAlpha = 1, strokeWidth = 4, badgeEncodings = undefined, columns = undefined }) {

    if (type !== 'point' || iconSize <= 15) {
        return null;
    }

    let pointColor;
    try {
        pointColor = new Color(pointRgb);
    } catch (e) {
        pointColor = new Color(0);
    }

    pointColor = pointColor.alpha(1).toString();

    const c = iconSize / 50;

    return (
        <div className={styles['point-icon-group']}>
            <div
                style={{
                    transform: `${`scale3d(${c},${c},${c})`} ${`translate3d(-100%, 0, 0)` /* force hardware acceleration */} ${`perspective(0px)` /* force sub-pixel font rendering when scaled */}`
                }}
                className={classNames({
                    [styles['point-icon-container']]: true,
                    [styles['light-color']]: !isDark(pointRgb)
                })}>
                {(iconClass || renderPoint) && (
                    <div
                        className={classNames({
                            [styles['point-icon']]: true,
                            [styles[`shape-${shape}`]]: true,
                            [styles['include-bg']]: !!renderPoint
                        })}
                        style={{
                            backgroundColor: pointColor,
                            opacity: pointAlpha,
                            '--icon-border': `${strokeWidth / 4}px`, // match original border to strokeWidth ratio
                        }}
                    >
                        { IconElt({iconClass, asText, shape}) }
                    </div>
                ) || undefined}
            </div>
            { badges({ badgeEncodings, columns, parentSize: iconSize })}
        </div>
    );
}

//Just icon, such as for label
// -> null | HTML
export function Icon({ iconClass, cssClass }) {

    const icon = IconElt({iconClass});

    return icon ? <span className={ cssClass }>{ icon }</span> : null;

}

// FA name or URL
// -> ? str<fa | url | data | text>
export function getIconClass({ encodings, type, columns = [] }) {
    if (!encodings || !encodings[type] || !encodings[type].icon) {
        return undefined;
    }

    return resolveIconClass({iconEncoding: encodings[type].icon, columns});

}

